import React, { useState } from 'react'
import { Button, Radio, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { changeEmailAlerts } from '../../../Redux/features/User/userSlice';
import { useCookies } from 'react-cookie'

const EmailAlert = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(state => state.user)

  const [matchMail, setMatchMail] = useState(user?.emailAlerts?.matchAndRecommendations)
  const [premiumMatchMail, setPremiumMatchMail] = useState(user?.emailAlerts?.premiumMatches)
  const [recentVisitor, setRecentVisitor] = useState(user?.emailAlerts?.profileVisitors)
  const [shortListedYou, setShortListedYou] = useState(user?.emailAlerts?.shortlisted)
  const [similar, setSimilar] = useState(user?.emailAlerts?.similarProfile)
  const [contact, setContact] = useState(user?.emailAlerts?.contact)
  const [message, setMessage] = useState(user?.emailAlerts?.message)
  const [inSite, setInSite] = useState(user?.emailAlerts?.lovodiInSite)
  const [lovodiSpecial, setLovodiSpecial] = useState(user?.emailAlerts?.lovodiSpecial)
  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    let data = {
        header: cookies['x-auth-token'],
    }




  const handleUpdate = () => {
    const dataa = {
      matchAndRecommendations: matchMail,
      premiumMatches: premiumMatchMail,
      profileVisitors: recentVisitor,
      shortlisted: shortListedYou,
      contact,
      message,
      similarProfile: similar,
      lovodiInSite: inSite,
      lovodiSpecial
    }

    dispatch(changeEmailAlerts({...data, ...dataa}))
  }
  // const handleReset = () => {
  //   setMatchMail()
  //   setPremiumMatchMail()
  //   setRecentVisitor()
  //   setShortListedYou()
  //   setSimilar()
  //   setContact()
  //   setMessage()
  //   setInSite()
  //   setLovodiSpecial()
  // }
  return (
    <div>
      <div className='emailAlertHeading'>My Alerts Manager</div>
      <div>
        Manage your subscriptions to Lovodi.com Alerts on email listed below. You can also subscribe to Shaadi.com and ShaadiTimes Newsletters.
      </div>
      <div className='emailAlertHeading'>My Alerts</div>

      <div className='mainEmailComp backgroundLight'>
        <div className='mainEmailComp2'>
          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Match Mail & Daily Recommendations Mail</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                Personalized matches for you delivered via email as often as you like. A very effective match-making tool.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setMatchMail(e.target.value === "Subscribe" ? true : false)} value={matchMail ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>

          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Premium Match Mail</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                An email notification containing your Matches who have upgraded to a Premium Membership
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setPremiumMatchMail(e.target.value === "Subscribe" ? true : false)} value={premiumMatchMail ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>


          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Recent Visitors Email</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                An email notification of Members who have recently Viewed your Profile
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setRecentVisitor(e.target.value === "Subscribe" ? true : false)} value={recentVisitor ? "Subscribe" : "Unsubscribe"}  >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>


          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Members who Shortlisted you Email</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                An email notification of Members who have recently Shortlisted your Profile
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setShortListedYou(e.target.value === "Subscribe" ? true : false)} value={shortListedYou ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>


          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Similar Profiles Email</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                An email containing Profiles that are similar to the ones you have liked recently.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setSimilar(e.target.value === "Subscribe" ? true : false)} value={similar ? "Subscribe" : "Unsubscribe"}  >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>



          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Contact Alert</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                Alerts you receive every time someone contacts you or you receive a response to a contact initiated by you. Get them in your mailbox at a frequency of your choice. Essential to keep you informed of all responses received.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setContact(e.target.value === "Subscribe" ? true : false)} value={contact ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>


          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Message Received Alert</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                An email notification of new messages received recently.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setMessage(e.target.value === "Subscribe" ? true : false)} value={message ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>
        </div>
        <div className='borderBottom'></div>
        <div className='backgroundGrey mt-4 newsletter'>
          Lovodi.com Newsletters
        </div>


        <div style={{ padding: 10 }}>
          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Lovodi Specials</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                Invitations, Discounts, and Offers just for Shaadi.com members. Offers range from free holidays to discounted jewellery. Delivered not more than twice a month.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setLovodiSpecial(e.target.value === "Subscribe" ? true : false)} value={lovodiSpecial ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>

          <div className='row d-flex justify-content-between' style={{ marginBottom: 20 }}>
            <div className='col-md-6'>
              <div className='tabHeading'>Lovodi InSite</div>
              <div style={{ marginTop: 10, color: "grey" }}>
                Advice and updates from Lovodi.com to help you get the most out of your Lovodi.com experience. A must-have.
              </div>
            </div>
            <div className='col-md-5'>
              <div className='tabHeading'>Email Alert</div>
              <Radio.Group onChange={(e) => setInSite(e.target.value === "Subscribe" ? true : false)} value={inSite ? "Subscribe" : "Unsubscribe"} >
                <Space direction="vertical">
                  <Radio value="Subscribe">Subscribe</Radio>
                  <Radio value="Unsubscribe">Unsubscribe</Radio>
                </Space>
              </Radio.Group>
            </div>
          </div>
        </div>
        <div className='borderBottom'></div>
        <div className='buttons'>
          <Button type="primary" onClick={handleUpdate}>Save</Button>
          {/* <Button onClick={handleReset}>Reset</Button> */}
        </div>
      </div>
    </div >
  )
}

export default EmailAlert
